import http from './http'
// import echart from 'echarts/dist/echarts.js'
// import Highcharts from 'highcharts/highstock'
// import HighchartsMore from 'highcharts/highcharts-more'
// import HighchartsDrilldown from 'highcharts/modules/drilldown'

// HighchartsMore(Highcharts)
// HighchartsDrilldown(Highcharts)
const defaulHead = require('../assets/default-head.png') 
var CommonPlugin = {};
CommonPlugin.install = (Vue, options) => {
    Vue.prototype.$MyAxios = http.MyAxios;
    window.$MyAxios = http.MyAxios;
    Vue.prototype.$DefaultHead = defaulHead
    window.$DefaultHead = defaulHead
    Vue.prototype.$setupWebViewJavascriptBridge = (callback) => {
        if (window.WebViewJavascriptBridge) {
            return callback(WebViewJavascriptBridge);
        }
        if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback);
        }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () {
            document.documentElement.removeChild(WVJBIframe)
        }, 0)
    }
    // Vue.prototype.$Echart = echart;
    // window.$Echart = echart;

    // Vue.prototype.$Highchart = Highcharts;
    // window.$Highchart = Highcharts;
}
export default CommonPlugin;